var map = {
	"./partner_logo_01.png": 395,
	"./partner_logo_02.png": 396,
	"./partner_logo_03.png": 397,
	"./partner_logo_04.png": 398,
	"./partner_logo_05.png": 399,
	"./partner_logo_06.png": 400,
	"./partner_logo_07.png": 401,
	"./partner_logo_08.png": 402,
	"./partner_logo_09.png": 403,
	"./partner_logo_10.png": 404,
	"./partner_logo_11.png": 405,
	"./partner_logo_12.png": 406,
	"./partner_logo_13.png": 407,
	"./partner_logo_14.png": 408,
	"./partner_logo_15.png": 409,
	"./partner_logo_16.png": 410,
	"./partner_logo_17.png": 411,
	"./partner_logo_18.png": 412,
	"./partner_logo_19.png": 413,
	"./partner_logo_20.png": 414,
	"./partner_logo_21.png": 415,
	"./partner_logo_22.png": 416,
	"./partner_logo_23.png": 417,
	"./partner_logo_24.png": 418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 394;